// @ts-strict-ignore
/**
 * @fileoverview GET handler for the "/app_settings/app_identifiers(/:app_group_id)" endpoint
 */
import fetch from "@lib/fetch";
import { serializeQueryObjects } from "@lib/serializeQueryObjects";

import { reactQueryTableFetcherAdapter } from "../reactQueryFetcherAdapters";
import { appSettingsAppIdentifiers } from "./constants";
import type { AppSettingsAppIdentifiersParams, AppSettingsAppIdentifiersResult } from "./types";

export const getDataTableAppSettingsAppIdentifiers = reactQueryTableFetcherAdapter(
  appSettingsAppIdentifiers,
  (
    signal: AbortSignal,
    { appGroupId, query, groupby, limit = 20, start = 0 }: AppSettingsAppIdentifiersParams
  ): Promise<AppSettingsAppIdentifiersResult> => {
    return fetch(
      `/app_settings/app_identifiers${appGroupId ? `/${appGroupId}` : ""}`,
      "GET",
      {
        groupby,
        limit,
        start,
        query: serializeQueryObjects(query),
      },
      { signal }
    );
  }
);
